(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
  $(".link-toggles .toggle-one").click(function() {
    $(this).addClass("active");
    $(".featured-collection__slider").addClass("link-1-active");
    $(".link-toggles .toggle-two").removeClass("active");
    $(".featured-collection__slider").removeClass("link-2-active");
    $(".image-carousel .product-item__image-link.image-link-two").hide();
    $(".image-carousel .product-item__image-link.image-link-one").fadeIn();
  });
  $(".link-toggles .toggle-two").click(function() {
    $(this).addClass("active");
    $(".featured-collection__slider").addClass("link-2-active");
    $(".link-toggles .toggle-one").removeClass("active");
    $(".featured-collection__slider").removeClass("link-1-active");
    $(".image-carousel .product-item__image-link.image-link-one").hide();
    $(".image-carousel .product-item__image-link.image-link-two").fadeIn();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events"] && !Shopify.designMode) return;
  try {
    
  $(".events__list .form-trigger").click(function() {
    var eventName = $(this).find(".event-item__name").attr("data-name");
    var eventVenue = $(this).find(".event-item__venue").attr("data-venue");
    var venueLocator = $(this).find(".event-item__venue").attr("data-locator");
    var eventSummary = $(this).find(".event-item__summary").attr("data-summary");
    var venueEmail = $(this).find(".venue-email").attr("data-email");
    $(".events-form h3").html(eventName);
    $(".events-form .venue").html(eventVenue).attr("href", "/pages/store-locator?stockist-query=" + venueLocator);
    $(".events-form .summary").html(eventSummary);
    $(".events-form .event-subject").val("Event Request for " + eventName + " - Veni Infantino Website");
    $(".events-form .event-cc").val(venueEmail);
    $(".events-form").fadeIn();
  })

  $(".events-form .form-overlay").click(function() {
    $(".events-form").fadeOut();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-events"] && !Shopify.designMode) return;
  try {
    
  $(".events__list .form-trigger").click(function() {
    var eventName = $(this).find(".event-item__name").attr("data-name");
    var eventAddress = $(this).find(".event-item__address").attr("data-address");
    var addressLocator = $(this).find(".event-item__address").attr("data-locator");
    var eventPhone = $(this).find(".event-item__phone").attr("data-phone");
    var venueEmail = $(this).find(".venue-email").attr("data-email");
    $(".events-form h3").html(eventName);
    $(".events-form .venue").html(eventAddress).attr("href", "/pages/store-locator?stockist-query=" + addressLocator);
    $(".events-form .phone").html(eventPhone);
    $(".events-form .event-subject").val("Event Request for " + eventName + " - Veni Infantino Website");
    $(".events-form .event-cc").val(venueEmail);
    $(".events-form").fadeIn();
  })

  $(".events-form .form-overlay").click(function() {
    $(".events-form").fadeOut();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  $(".column-toggle.full").click(function() {
    $(this).addClass("active");
    $(".column-toggle.half").removeClass("active");    
    $(this).closest(".collection__content").find(".collection__main-area .collection__products").addClass("collection__fullwidth");
  });
  $(".column-toggle.half").click(function() {
    $(this).addClass("active");
    $(".column-toggle.full").removeClass("active");    
    $(this).closest(".collection__content").find(".collection__main-area .collection__products").removeClass("collection__fullwidth");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page--contact"]) return;
  try {
    
  $(".contact-buttons .contact-yes").click(function() {
    $(this).addClass("active");
    $(".contact-buttons .contact-no").removeClass("active");
    $(".contact__form").slideDown();
    $(".stockist-note").hide()
  });
  $(".contact-buttons .contact-no").click(function() {
    $(this).addClass("active");
    $(".contact-buttons .contact-yes").removeClass("active");
    $(".contact__form").hide();
    $(".stockist-note").slideDown()
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premier-stockists"] && !Shopify.designMode) return;
  try {
    
  $(".events__list .form-trigger").click(function() {
    var stockistName = $(this).parent().find(".event-item__name").attr("data-name");
    var stockistEmail = $(this).parent().find(".stockist-email").attr("data-email");
    $(".events-form h3").html(stockistName);
    $(".events-form .event-cc").val(stockistEmail);
    $(".events-form").fadeIn();
  })

  $(".events-form .form-overlay").click(function() {
    $(".events-form").fadeOut();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  if (window.location.href.indexOf("stockist-query") > -1) {
    var stockistQuery = (new URL(location.href)).searchParams.get('stockist-query').replaceAll(" ", "%20");
    console.log(stockistQuery);
    $('.stockist-countries select option[value="' + stockistQuery + '"]').attr('selected', 'selected')
  }
  
  $(".stockist-countries select").on("change", function() {
    var selectedCountry = $(this).val();
    if(selectedCountry == "All") {
      var locatorUrl = "/pages/store-locator";
    } else {
      var locatorUrl = "/pages/store-locator?stockist-query=" + selectedCountry;
    }
    window.location.href = locatorUrl;
  });

  } catch(e) { console.error(e); }
})();
})();
